<template>
  <div>
    <v-select
      :items="items"
      item-title="label"
      item-value="value"
      :model-value="modelValue"
      @update:model-value="inputAge"
      variant="outlined"
      density="compact"
      hide-details
      color="primary"
    >
    </v-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ageItems } from "@/constants/attendance";

export default defineComponent({
  name: "AgePicker",

  emits: ["update:modelValue"],

  props: {
    modelValue: {
      type: [Number, null] as PropType<number | null>,
      required: false,
      default: null,
    },
  },

  methods: {
    inputAge(value: number | null) {
      this.$emit("update:modelValue", value);
    },
  },

  computed: {
    items() {
      return ageItems.map((item) => ({
        label: item.text,
        value: item.value === "" ? null : item.value,
      }));
    },
  },
});
</script>
